import { render, staticRenderFns } from "./CamposScfv.vue?vue&type=template&id=28ced011"
import script from "./CamposScfv.vue?vue&type=script&lang=js"
export * from "./CamposScfv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports